import { useEffect, useState } from "react";
import "./PagoSwitch.css";

// "2026-08-25T14:30:00.000Z" -> "2026-08-25T14:30" (para <input type="datetime-local">)
const toDatetimeLocalValue = (d) => {
  const date = d ? new Date(d) : new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const fmtFechaPago = (iso) => {
  try {
    return new Date(iso).toLocaleString("es-MX", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

// Switch "¿ya se pagó?" + fecha/hora que elige el admin, con guardado explícito.
// onSave(({ pagado, pagadoAt })) -> Promise
// locked: la semana todavía no terminó — el número puede seguir cambiando, así que
// no se puede marcar como pagado todavía (el backend también lo bloquea).
export default function PagoSwitch({ pagado, pagadoAt, onSave, label = "Pagado", locked = false, lockedMessage }) {
  const [checked, setChecked] = useState(!!pagado);
  const [fecha, setFecha] = useState(() => toDatetimeLocalValue(pagadoAt));
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    if (dirty) return; // no pisar una edición a medias (fecha sin guardar todavía)
    setChecked(!!pagado);
    setFecha(toDatetimeLocalValue(pagadoAt));
  }, [pagado, pagadoAt, dirty]);

  const handleToggle = async (e) => {
    const next = e.target.checked;
    setChecked(next);
    if (!next) {
      // Desmarcar: se guarda directo, no hace falta confirmar fecha
      setSaving(true);
      await onSave({ pagado: false, pagadoAt: null });
      setSaving(false);
      setDirty(false);
    } else {
      setDirty(true);
    }
  };

  const handleGuardar = async () => {
    if (!fecha) return;
    setSaving(true);
    await onSave({ pagado: true, pagadoAt: new Date(fecha).toISOString() });
    setSaving(false);
    setDirty(false);
  };

  return (
    <div className="pago-switch">
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          checked={checked}
          disabled={saving || locked}
          onChange={handleToggle}
        />
        <label className="form-check-label small">{label}</label>
      </div>

      {locked && (
        <div className="small text-muted">{lockedMessage || "Disponible cuando termine la semana"}</div>
      )}

      {!locked && checked && dirty && (
        <div className="pago-switch-fecha">
          <input
            type="datetime-local"
            className="form-control form-control-sm"
            value={fecha}
            disabled={saving}
            onChange={(e) => setFecha(e.target.value)}
          />
          <button
            type="button"
            className="btn btn-sm btn-success"
            disabled={saving || !fecha}
            onClick={handleGuardar}
          >
            {saving ? "..." : "Guardar"}
          </button>
        </div>
      )}

      {checked && !dirty && pagadoAt && (
        <div className="pago-switch-fecha-txt small text-muted">✅ {fmtFechaPago(pagadoAt)}</div>
      )}
    </div>
  );
}
